<template>
  <div>
    <portal-target name="dropdown" slim />
    <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:flex-shrink-0">
          
          <div class="bg-white md:flex-shrink-0 md:w-13 px-4 py-3">
            <label> Sion 1.0  </label>
          </div>
          <div class="bg-white border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center">
            <div class="mt-1 mr-4"></div>
            <dropdown class="mt-1" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
                <div class="text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 mr-1 whitespace-nowrap">
                  <span>{{ $page.props.auth.user.first_name }}</span>
                  <span class="hidden md:inline">{{ $page.props.auth.user.last_name }}</span>
                </div>
                <icon class="w-5 h-5 group-hover:fill-indigo-600 fill-gray-700 focus:fill-indigo-600" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('users.edit', $page.props.auth.user.id)">My Profile</inertia-link>
                <inertia-link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('users')">Manage Users</inertia-link>
                <inertia-link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white w-full text-left" :href="route('logout')" method="delete" as="button">Logout</inertia-link>
              </div>
            </dropdown>
          </div>
        </div>

     <Menu v-if="$page.props.auth.user.rol == 'Gerencia'"  class="mb-4" />
     <MenuFiscalizador v-if="$page.props.auth.user.rol == 'Fiscalizador'"  class="mb-4" />
     <MenuMecanica v-if="$page.props.auth.user.rol == 'Mecanica'"  class="mb-4" />
     <MenuCompras v-if="$page.props.auth.user.rol == 'Compras'"  class="mb-4" />
     <MenuContabilidad v-if="$page.props.auth.user.rol == 'Contabilidad'"  class="mb-4" />
     <MenuFinanciero v-if="$page.props.auth.user.rol == 'Financiero'"  class="mb-4" />
     <MenuObras v-if="$page.props.auth.user.rol == 'Obras'"  class="mb-4" />
     <MenuBodega v-if="$page.props.auth.user.rol == 'Bodega'"  class="mb-4" />
     <MenuArchivo v-if="$page.props.auth.user.rol == 'Archivo'"  class="mb-4" />



     <MenuAdmin v-if="$page.props.auth.user.rol == 'Admin'"  class="mb-4" />

        <div class="md:flex md:flex-wrap" style="margin-left: 70px;">     
          
          <!--   <main-menu ref="mm" v-show="show" class="md:block bg-green-900 flex-shrink-0 w-56 p-12 overflow-y-auto" />-->

          <div class="md:flex-1 px-4 py-8 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'

import FlashMessages from '@/Shared/FlashMessages'
import Menu from '@/Shared/Menu'
import MenuAdmin from '@/Shared/MenuAdmin'
import MenuFiscalizador from '@/Shared/MenuFiscalizador'
import MenuMecanica from '@/Shared/MenuMecanica'
import MenuBodega from '@/Shared/MenuBodega'
import MenuCompras from '@/Shared/MenuCompras'
import MenuFinanciero from '@/Shared/MenuFinanciero'
import MenuObras from '@/Shared/MenuObras'
import MenuArchivo from '@/Shared/MenuArchivo'
import MenuContabilidad from '@/Shared/MenuContabilidad'



export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Logo,
    MainMenu,
    Menu,
    Logo,
    MenuAdmin,
    MenuArchivo,
    MenuBodega,
    MenuCompras,
    MenuFinanciero,
    MenuFiscalizador,
    MenuMecanica,
    MenuObras,
    MenuContabilidad,
  },
  data() {
    return {
      show: true,
    }
  },
  methods: {
  }
}
</script>